import { useContext, useEffect } from "react";
import { useToast, ToastPosition } from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";

const ToastNotification = () => {
  const toast = useToast();
  const { notify, toastNotify } = useContext(AppContext);

  useEffect(() => {
    if (notify) {
      toast({
        title: notify.title,
        description: notify.message,
        status: notify.type ? notify.type : 'success',
        duration: 9000,
        isClosable: true,
        position: notify.placement
          ? (notify.placement as ToastPosition)
          : "top-right",
      });

      setTimeout(() => {
        toastNotify(null);
      }, 5000);
    }
  }, [notify, toast, toastNotify]);
  return null;
};

export default ToastNotification;
